export const GET_USER_TRANSACTION_REQUEST = 'GET_USER_TRANSACTION_REQUEST';
export const GET_USER_TRANSACTION_SUCCESS = 'GET_USER_TRANSACTION_SUCCESS';
export const GET_USER_TRANSACTION_ERROR   = 'GET_USER_TRANSACTION_ERROR';
